export const mergeUsingId = <T extends {id: number}>(items: T[], newItems: T[]): T[] => {
    const indexById = (list: T[]) => Object.fromEntries(list.map((item) => [item.id, item]));
    const mergedById = Object.assign({}, indexById(items), indexById(newItems));

    return Object.values(mergedById);
};